export default __webpack_public_path__ + "media/images/user/new-66a8394fff25858ef3afad3263dfa8b2.png";